interface BubbleStyleConfig {
  readonly backgroundColor: string
  readonly borderWidth: number
  readonly borderOpacity: number
  readonly borderRadius: number
  readonly padding: number
  readonly marginBottom: number
}

interface ActorHeaderLineConfig {
  readonly style: 'dotted' | 'solid' | 'dashed'
  readonly color: string
  readonly width: number
}

interface ActorHeaderStyleConfig {
  readonly fontSize: string
  readonly fontWeight: number
  readonly letterSpacing: string
  readonly textTransform: 'uppercase' | 'lowercase' | 'capitalize' | 'none'
  readonly color: string
  readonly line: ActorHeaderLineConfig
  readonly marginBottom: number
  readonly marginTop: number
}

interface BubbleDefaults {
  readonly agent: BubbleStyleConfig
  readonly user: BubbleStyleConfig
  readonly notification: BubbleStyleConfig
  readonly error: BubbleStyleConfig
  readonly status: BubbleStyleConfig
}

interface BubbleStyleDefaults {
  readonly bubbles: BubbleDefaults
  readonly actorHeader: ActorHeaderStyleConfig
}

export const DEFAULT_BUBBLE_STYLES: BubbleStyleDefaults = {
  bubbles: {
    agent: {
      backgroundColor: 'transparent',
      borderWidth: 3,
      borderOpacity: 0.6,
      borderRadius: 0,
      padding: 1.5,
      marginBottom: 2,
    },
    user: {
      backgroundColor: 'transparent',
      borderWidth: 3,
      borderOpacity: 0.6,
      borderRadius: 0,
      padding: 1.5,
      marginBottom: 2,
    },
    notification: {
      backgroundColor: 'transparent',
      borderWidth: 3,
      borderOpacity: 0.6,
      borderRadius: 0,
      padding: 1.5,
      marginBottom: 2,
    },
    error: {
      backgroundColor: 'transparent',
      borderWidth: 3,
      borderOpacity: 0.6,
      borderRadius: 0,
      padding: 1.5,
      marginBottom: 2,
    },
    status: {
      backgroundColor: 'transparent',
      borderWidth: 0,
      borderOpacity: 0,
      borderRadius: 0,
      padding: 0,
      marginBottom: 2,
    },
  },
  actorHeader: {
    fontSize: '1.08rem',
    fontWeight: 500,
    letterSpacing: '0.02em',
    textTransform: 'none',
    color: 'rgba(255, 255, 255, 0.4)',
    line: {
      style: 'dotted',
      color: 'rgba(255, 255, 255, 0.08)',
      width: 1,
    },
    marginBottom: 4,
    marginTop: 4,
  },
} as const

export type { BubbleStyleConfig, ActorHeaderStyleConfig, BubbleDefaults, BubbleStyleDefaults }
